import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import './styles.css'
import qs from 'query-string'

let generateQueryParams = (params, page) => {
  let extended = {
    ...params,
    page: page
  }
  return qs.stringify(extended)
}

let renderItem = (url, params, name, index, isActive, isDisabled) => {
  let query = generateQueryParams(params, index)

  return (<li key={index} className={"page-item " + (isDisabled ? 'disabled' : '') + (isActive ? 'active' : '')}>
    <Link className="page-link" to={url + '?' + query}>{name}</Link>
  </li>)
}

const Pagination = ({ totalItems, itemsPerPage, page, url, params = {} }) => {
  const parsedItemsPerPage = parseInt(itemsPerPage, 10)
  const parsedPage = parseInt(page, 10)
  const safeItemsPerPage = parsedItemsPerPage > 0 ? parsedItemsPerPage : 1
  const safePage = parsedPage > 0 ? parsedPage : 1
  const totalPages = Math.max(1, Math.ceil(Number(totalItems) / safeItemsPerPage))

  const linksBefore = []
  for (let index = safePage; index >= (safePage - 5); index--) {
    if (index > 0 && index !== safePage) {
      linksBefore.unshift(
        renderItem(url, params, index, index, index === safePage, false)
      )
    }
  }

  const linksAfter = []
  for (let index = safePage; index <= (safePage + 5); index++) {
    if (index <= totalPages && index !== safePage) {
      linksAfter.push(
        renderItem(url, params, index, index, index === safePage, false)
      )
    }
  }

  const pageRangeEnd = totalItems < (safeItemsPerPage * safePage)
    ? totalItems
    : (safeItemsPerPage * safePage)

  return (
    <div>
      <ul className="pagination" aria-label="Pagination Navigation">
        {renderItem(url, params, 'Previous', (safePage - 1), false, (safePage - 1 < 1))}
        {linksBefore}
        {renderItem(url, params, safePage, safePage, true, false)}
        {linksAfter}
        {renderItem(url, params, 'Next', (safePage + 1), false, (safePage + 1 > totalPages))}
      </ul>
      <div className="well-sm">
        Results <strong>{(safeItemsPerPage * safePage) - (safeItemsPerPage - 1)}-{pageRangeEnd}</strong> of <strong>{totalItems}</strong>
      </div>
    </div>
  )
}

Pagination.propTypes = {
  totalItems: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  itemsPerPage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  page: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  url: PropTypes.string.isRequired,
  params: PropTypes.object
}

Pagination.defaultProps = {
  params: {},
  totalItems: 0
}
export default Pagination



// WEBPACK FOOTER //
// ./src/components/pagination/index.js